import {NameId} from '@drl/core/models';
import {SelectItem} from 'primeng/api';

import {TreatmentType} from '../enums/treatment-types.enum';

export class TherapyPlan {
  id?: number;
  externalId: string;
  patientId: number;
  appointmentId?: number;
  treatmentType: TreatmentType;
  intent?: string;
  cyclesCount: number;
  daysInCycle: number;
  frequency: number;
  days: string;
  startDate: string;
  therapyDrugs?: TherapyDrugs[];
  dates: SelectItem[];
  modifiedOn: Date;
}

export class TherapyDrugs extends NameId {
  drugExtId: string;
  dosage: number;
  route: string;
  therapyPlanId?: number;
}
